import React from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Column, H2, Image } from 'components/atoms';
import { Cities } from 'components/molecules';
import { getNearbyCities } from 'store/selectors/getNearbyFacilities';
import { useSelector } from 'react-redux';
import './StorageNearYou.scss'
import { stateWiseCities } from 'utils/data/PSPCities';
import { StorageNearYouData } from 'pages/StyleGuidePage/nearbyCities';

export function StorageNearYou() {
	const nearbyCities = useSelector((state) => getNearbyCities(state));
	const geolocation = useSelector((state) => state.user.geolocation);

	const { title, image, nearByDetectedCities, statesLink } = StorageNearYouData;
	const citiesByState = stateWiseCities.find(
		(stateInfo) => stateInfo.abbreviation === geolocation.region || stateInfo.state === geolocation.region
	);
	const nearByCitiesData = {
		...nearByDetectedCities,
		title: nearByDetectedCities.title + geolocation.city,
		cities: nearbyCities
			.map((item) => ({
				...item,
				name: `${item.city}, ${item.state}`,
				slug: item.url,
			}))
			.slice(0, 7),
	};

	const citiesByStateData = citiesByState
		? {
				...nearByDetectedCities,
				title:
					nearByDetectedCities.title +
					(citiesByState.state ?? stateInfo.abbreviation),
				cities: citiesByState.cities.slice(0, 7).map((city) => {
					const formattedCity = citiesByState?.abbreviation
						? `${city.name}, ${citiesByState.abbreviation}`
						: city.name;
					return { ...city, name: formattedCity };
				}),
			}
		: null;

	const statesLinkData = {
		...statesLink,
		cities: statesLink.cities.slice(0, 7),
	};
    return (
		<section className="section-container storage-near-you">
			<Container>
				<Image
					src={image}
					alt="featured-cities-icon"
					className="featured-cities-icon"
				/>
				<H2
					size="large"
					className="nearby-cities-title"
				>
					{title}
				</H2>
				<Row>
					{nearByCitiesData && (
						<Column
							medium={12}
							large={4}
						>
							<Cities {...nearByCitiesData} />
						</Column>
					)}
					{citiesByStateData && (
						<Column
							medium={12}
							large={4}
						>
							<Cities {...citiesByStateData} />
						</Column>
					)}
					{statesLinkData && (
						<Column
							medium={12}
							large={4}
						>
							<Cities {...statesLinkData} />
						</Column>
					)}
				</Row>
			</Container>
		</section>
	);
}

StorageNearYou.propTypes = {
	title: PropTypes.string,
	image: PropTypes.string,
	geolocation: PropTypes.object,
	nearbyCities: PropTypes.arrayOf(PropTypes.object),
	nearByDetectedCities: PropTypes.object,
	statesLink: PropTypes.object,
};

export default StorageNearYou;
